import config from "@/settings/config";

// eslint-disable-next-line import/prefer-default-export
export const convertImageUri = imagePath => {
  if (imagePath.startsWith(config.storageServerUrl)) {
    return imagePath;
  }
  return imagePath && `${config.storageServerUrl}${imagePath}`;
};
